import apiConfig from "../ApiConfig";

export const getRiskDataApi = async (search = '', status = '', severity = '', page = 1, limit = 10, sort = 'desc', sortBy = 'created_at', columnFilters = []) => {
    try {
        const response = await apiConfig.get('/api/risks-management/risks/', {
            params: {
                search: search || undefined,
                status: status || undefined,
                severity: severity || undefined,
                page: page,
                limit: limit,
                sort,
                sort_by: sortBy,
                column_filters: columnFilters.length ? JSON.stringify(columnFilters) : undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risks:', error);
        throw error;
    }
};
export const getCustomerRiskApi = async (search = '', status = '', severity = '', page = 1, limit = 10, userId, sort = 'desc', sortBy = 'created_at', columnFilters = []) => {
    console.log('Fetching customer risks with params:', { search, status, severity, page, limit, userId });
    try {
        const response = await apiConfig.get('/api/risks-management/customer/risks/', {
            params: {
                search: search || undefined,
                status: status || undefined,
                severity: severity || undefined,
                page: page,
                limit: limit,
                customer_id: userId,
                sort,
                sort_by: sortBy,
                column_filters: columnFilters.length ? JSON.stringify(columnFilters) : undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error saving risk:', error);
        throw error;
    }
};
export const getCustomerRiskControlOptionsApi = async () => {
    try {
        const response = await apiConfig.get('/api/risks-management/customer/risks/control-options/');
        return response.data;
    } catch (error) {
        console.error('Error fetching customer risk control options:', error);
        throw error;
    }
};

export const getCustomerRiskApprovalQueueApi = async () => {
    try {
        const response = await apiConfig.get('/api/risks-management/customer-risk-approvals/');
        return response.data;
    } catch (error) {
        console.error('Error fetching customer risk approvals:', error);
        throw error;
    }
};

export const decideCustomerRiskApprovalApi = async (riskId, decision, reason = '') => {
    try {
        const action = decision === 'approved' ? 'approve' : 'decline';
        const response = await apiConfig.post(
            `/api/risks-management/customer-risk-approvals/${riskId}/${action}/`,
            decision === 'rejected' ? { reason } : {},
        );
        return response.data;
    } catch (error) {
        console.error(`Error ${decision} customer risk:`, error);
        throw error;
    }
};

// Dedicated Risk Analysis endpoint - independent of getCustomerRiskApi
// (Risk Register), per explicit request to isolate Risk Analysis's own
// fetch/filter wiring.
export const getRiskAnalysisListApi = async (customerId, page = 1, limit = 10, columnFilters = []) => {
    try {
        const response = await apiConfig.get('/api/risks-management/risk-analysis/list/', {
            params: {
                customer_id: customerId,
                page,
                limit,
                column_filters: columnFilters.length ? JSON.stringify(columnFilters) : undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risk analysis list:', error);
        throw error;
    }
};

// Dedicated Risk Evaluation endpoint - independent of getCustomerRiskApi
// and getRiskAnalysisListApi, same isolation reasoning.
export const getRiskEvaluationListApi = async (customerId, page = 1, limit = 10, columnFilters = []) => {
    try {
        const response = await apiConfig.get('/api/risks-management/risk-evaluation/list/', {
            params: {
                customer_id: customerId,
                page,
                limit,
                column_filters: columnFilters.length ? JSON.stringify(columnFilters) : undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risk evaluation list:', error);
        throw error;
    }
};

// Dedicated Risk Treatment Plan endpoint - independent of the other
// risk-list fetches, same isolation reasoning.
export const getRiskTreatmentListApi = async (customerId, page = 1, limit = 10, columnFilters = []) => {
    try {
        const response = await apiConfig.get('/api/risks-management/risk-treatment/list/', {
            params: {
                customer_id: customerId,
                page,
                limit,
                column_filters: columnFilters.length ? JSON.stringify(columnFilters) : undefined,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risk treatment list:', error);
        throw error;
    }
};

export const updateRiskApi = async (riskData, riskId) => {
    try {
        const response = await apiConfig.put(`/api/risks-management/update/${riskId}/`, riskData,);
        return response.data;
    } catch (error) {
        console.error('Error updating risk:', error);
        throw error;
    }
};
export const updateCustomerRiskApi = async (riskData, riskId) => {
    try {
        const response = await apiConfig.put(`/api/risks-management/customer/risks/${riskId}/update/`, riskData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating risk:', error);
        throw error;
    }
};

export const deleteRiskApi = async (riskId) => {
    try {
        const response = await apiConfig.delete(`/api/risks-management/delete/${riskId}/`);
        return response.data;
    } catch (error) {
        console.error('Error deleting risk:', error);
        throw error;
    }
};
export const deleteCustomerRiskApi = async (riskId) => {
    try {
        const response = await apiConfig.delete(`/api/risks-management/customer/risks/${riskId}/delete/`);
        return response.data;
    } catch (error) {
        console.error('Error deleting risk:', error);
        throw error;
    }
};
export const saveRiskApi = async (riskData) => {
    try {
        const response = await apiConfig.post('/api/risks-management/create/', riskData);
        return response.data;
    } catch (error) {
        console.error('Error saving risk:', error);
        throw error;
    }
};
export const saveCustomerRiskApi = async (riskData) => {
    try {
        const response = await apiConfig.post('/api/risks-management/customer/risks/create/', riskData);
        return response.data;
    } catch (error) {
        console.error('Error saving risk:', error);
        throw error;
    }
}
export const saveRemarksApi = async (riskId, remarks) => {
    try {
        const response = await apiConfig.put(`/api/risks-management/update-remarks/${riskId}`, { remarks });
        return response.data;
    } catch (error) {
        console.error('Error saving remarks:', error);
        throw error;
    }
};

export const createRiskTreatmentPlanApi = async (riskId, treatmentData) => {
    try {
        const response = await apiConfig.post(`/api/risks-management/treatment/${riskId}/add/`, treatmentData);
        return response.data;
    } catch (error) {
        console.error('Error creating risk treatment plan:', error);
        throw error;
    }
};

export const updateRiskTreatmentPlanApi = async (treatmentData, treatmentId) => {
    try {
        const response = await apiConfig.put(`/api/risks-management/treatment/${treatmentId}/update/`, treatmentData, {
            headers: {
                'Content-Type': 'multipart/form-data'
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error updating risk treatment plan:', error);
        throw error;
    }
};

export const reportRiskApi = async (reportType, userId, action, userRole) => {
    console.log({ userRole })
    try {
        const response = await apiConfig.get(`/api/risks-management/reports/${reportType}`, {
            params: { userId, action, userRole }
        });
        return response.data;

    } catch (error) {
        console.error('Error generating report:', error);
        throw error;
    }
}

export const reportRiskDownloadApi = async (reportType, userId, action, userRole, format = "csv") => {
    try {
        const response = await apiConfig.get(
            `/api/risks-management/reports/${reportType}`,
            {
                params: { userId, action, userRole, format },
                responseType: "blob",
            }
        );

        if (response.status !== 200) {
            throw new Error("Failed to download report");
        }
        const contentDisposition = response.headers["content-disposition"];
        let filename = `${reportType}_${new Date()
            .toISOString()
            .split("T")[0]}.${format}`;

        if (contentDisposition) {
            const match = contentDisposition.match(/filename="?([^"]+)"?/);
            if (match && match[1]) {
                filename = match[1];
            }
        }
        const blob = response.data;
        return {
            blob,
            filename,
        };

    } catch (error) {
        console.error("Error generating report:", error);
        throw error;
    }
};
export const getAIInsightApi = async (payload) => {
    try {
        const response = await apiConfig.post('/api/risks-management/ai-insights', payload);
        return response.data;
    } catch (error) {
        console.error('Error fetching AI insights:', error);
        throw error;
    }
};
export const RiskDashboardApi = async (userId) => {
    try {
        const response = await apiConfig.get(`/api/risks-management/dashboard/`, {
            params: { userId }
        });
        return response.data;
    } catch (error) {
        console.error('Error generating report:', error);
        throw error;
    }
}
export const getRiskAssignToApi = async (riskId) => {
    try {
        const response = await apiConfig.get(`/api/risks-management/risk/get-assigned-emp/`, {
            params: { customer_risk_response_id: riskId }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risk assign to:', error);
        throw error;
    }
};
export const assignRiskApi = async (assignmentData) => {
    try {
        const response = await apiConfig.post('/api/risks-management/risk/assign/', assignmentData);
        return response.data;
    } catch (error) {
        console.error('Error assigning risk:', error);
        throw error;
    }
};

export const fetchTreatmentFileApi = async (treatmentId) => {
    try {
        const response = await apiConfig.get(`api/risks-management/treatment/${treatmentId}/get-file`)
        return response;
    } catch (err) {
        console.error('Error fetching treatment file', err)
        throw err;
    }
}

export const fetchEvaluationFileApi = async (riskId) => {
    try {
        const response = await apiConfig.get(`api/risks-management/customer/risk/${riskId}/get-evaluation-file`)
        return response;
    } catch (err) {
        console.error('Error fetching evaluation file', err)
    }
}

export const getRiskHistorySnapshotApi = async ({ userId, fromDate, toDate, search = '', status = '', severity = '', page = 1, limit = 10 }) => {
    try {
        const response = await apiConfig.get('/api/risks-management/reports/get-snap-short', {
            params: {
                userId,
                fromDate: fromDate || undefined,
                toDate: toDate || undefined,
                search: search || undefined,
                status: status || undefined,
                severity: severity || undefined,
                page,
                limit,
            }
        });
        return response.data;
    } catch (error) {
        console.error('Error fetching risk history snapshot:', error);
        throw error;
    }
};